import { render, staticRenderFns } from "./Display2.vue?vue&type=template&id=88e10652&scoped=true&"
import script from "./Display2.vue?vue&type=script&lang=js&"
export * from "./Display2.vue?vue&type=script&lang=js&"
import style0 from "./Display2.vue?vue&type=style&index=0&id=88e10652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e10652",
  null
  
)

export default component.exports